<h6 class="siteList__title">
  {{ 'select_site' | ppTranslate }}
</h6>

@for (account of ppAccounts; track account) {
  <div
    class="siteList__account"
    [class.account--expanded]="expandedAccounts.includes(account.accountId)"
    >
    <div
      class="siteList__accountName"
      [class.siteList__accountName--expanded]="expandedAccounts.includes(account.accountId)"
      (click)="toggleAccount(account.accountId)"
      >
      <img
        [class.arrowDown]="expandedAccounts.includes(account.accountId)"
        [src]="EIconPath.INTERACTION_EXPAND_ICON"
        />
      <h6 class="siteList__accountName--text">
        {{ account.accountName }}
      </h6>
      @if (
        !expandedAccounts.includes(account.accountId) &&
        ppFieldsPerAccount[account.accountId] &&
        ppFieldsPerAccount[account.accountId] > 1
        ) {
        <p
          class="selectedCustomFieldsCounter copy"
          >
          {{ ppFieldsPerAccount[account.accountId] }}
          {{ SiteListSelectTypesMultiple[ppType] | ppTranslate }}
        </p>
      }
      @if (
        !expandedAccounts.includes(account.accountId) &&
        ppFieldsPerAccount[account.accountId] &&
        ppFieldsPerAccount[account.accountId] === 1
        ) {
        <p
          class="selectedCustomFieldsCounter copy"
          >
          {{ ppFieldsPerAccount[account.accountId] }}
          {{ SiteListSelectTypesSingle[ppType] | ppTranslate }}
        </p>
      }
    </div>
    @if (expandedAccounts.includes(account.accountId)) {
      @for (workspace of account.workspaces; track workspace; let last = $last) {
        <pp-site-list-select-field
          [ppActiveWorkspaceId]="activeWorkspaceId"
          [ppFieldsPerWorkspace]="ppFieldsPerWorkspace"
          [ppType]="ppType"
          [ppWorkspaceId]="workspace"
          [ppWorkspace]="workspaces[workspace]"
          (ppAction)="openSiteCallback($event)"
        ></pp-site-list-select-field>
      }
    }
  </div>
}
